import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  // Loader flag
  loaderVisibility = new BehaviorSubject(false);

  constructor() { }

  /**
   * @desc To toggle the loader visibility
   * @param  {boolean} flag
   */
  toggleLoader(flag) {
    // var bodyElem = document.getElementsByTagName('body')[0];
    // if(flag) {
    //   bodyElem.style.overflow = 'hidden';
    // } else {
    //   bodyElem.style.overflow = 'auto';
    // }
    this.loaderVisibility.next(flag);
  }

}
